import { useEffect, useState } from 'react';
import { createRoute, stripSearchParams } from '@tanstack/react-router';

import { rootRoute } from '../routerBase';
import { PORTAL_APPS_SEARCH_DEFAULTS, parsePortalAppsSearch } from '../../hooks/portalApps/usePortalAppsRouterSearch';
import { TableViewSkeleton } from '../../components/Skeleton/TableViewSkeleton';
import { useTranslation } from '../../hooks/useTranslation';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
// Type-only import so the route bundle stays split; the module is loaded with
// a dynamic import() inside the route's effect.
import type PortalAppManagement from '../../components/PortalAppManagement/index';

export const portalAppsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/portal_apps',
  validateSearch: parsePortalAppsSearch,
  search: { middlewares: [stripSearchParams(PORTAL_APPS_SEARCH_DEFAULTS)] },
  component: function PortalAppsIndexRoute() {
    const { t } = useTranslation();
    useDocumentTitle(t('common.page_titles.portal_apps'));
    const [Component, setComponent] = useState<typeof PortalAppManagement | null>(null);
    useEffect(() => {
      import('../../components/PortalAppManagement/index').then((mod) => {
        setComponent(() => mod.default);
      });
    }, []);
    if (!Component) {
      return <TableViewSkeleton label={t('header.title')} />;
    }
    return <Component />;
  },
});
